import { css } from 'styled-components';
import { CtaWrapper, StyledSecondaryCta } from '../../../../components/CtaBanner/styles';
import mediaQuery from '../../../../helpers/mediaQuery';

export default css`
  ${StyledSecondaryCta} {
    border-width: 2px;
    width: max-content;
  }

  ${CtaWrapper} {
    align-self: flex-start;
    width: 100%;
    ${mediaQuery.tabletPortrait`
        width: initial;
      `}
  }
`;
